import { Button as MUIButton, ButtonBaseProps } from "@mui/material";
import { useState } from "react";
import { Box } from "./Box";
import { Text } from "./Text";
import { Modal } from "./Modal";
import { useTheme } from "@mui/material";

type ButtonType = {
  textconfirm?: string;
  withconfirm?: boolean;
  onClick?: any;
  loading?: boolean;
  color?: "blueSky" | "green" | "grey" | "magenta" | "orange" | "pink" | "purple" | "purplePink" | "red" | "yellow";
} & ButtonBaseProps;

const ButtonCpn = ({ color, ...props }: ButtonType) => {
  const theme = useTheme();

  return (
    <MUIButton
      {...props}
      sx={{
        backgroundColor: color ? theme.colors[color]?.pale : theme.colors.light,
        padding: "2px 14px",
        minHeight: 28,
        borderRadius: 2,
        color: "#1f1f1f",
        fontWeight: 400,
        textTransform: "inherit",
        "&:hover": {
          background: "#efefef",
          backgroundColor: color ? theme.colors[color]?.main : theme.colors.primary,
          color: "white",
        },
        ...props?.style,
      }}
    />
  );
};

export function Button({ textconfirm, withconfirm, onClick, loading, ...props }: ButtonType) {
  const [open, setOpen] = useState(false);

  if (withconfirm) {
    return (
      <>
        <ButtonCpn textconfirm={textconfirm} {...props} onClick={() => setOpen(true)} />
        <Modal open={open}>
          <Text fontSize="22px" fontWeight="600">
            Confirmer ?
          </Text>
          <Box p={2}>
            <Text>{textconfirm ? textconfirm : "Etes-vous sûr de vouloir supprimer cet élément ?"}</Text>
          </Box>
          <Box p={2}>
            <MUIButton
              style={{
                backgroundColor: "#ebebeb",
                padding: "2px 10px",
                height: 28,
                borderRadius: 3,
                color: "#303030",
                fontWeight: 600,
              }}
              onClick={() => setOpen(false)}
            >
              Non
            </MUIButton>
            <Box p={2} />
            <MUIButton
              style={{
                backgroundColor: "#ebebeb",
                padding: "2px 10px",
                height: 28,
                borderRadius: 3,
                color: "#303030",
                fontWeight: 600,
              }}
              onClick={() => {
                onClick();
                setOpen(false);
              }}
            >
              Oui
            </MUIButton>
          </Box>
        </Modal>
      </>
    );
  }
  return <ButtonCpn textconfirm={textconfirm} onClick={onClick} disabled={loading || props?.disabled} {...props} />;
}
